import {Actionable, ActionableType} from '@/assignments/Assignment.type'
import ApproveCellRenderer from '@/assignments/ApproveActionable/ApproveCellRenderer.vue'
import BookkeepingCellRenderer from '@/assignments/BookkeepingActionable/BookkeepingCellRenderer.vue'
import {h} from 'vue'
import SubAccountCreatableCellRenderer from '@/assignments/SubAccountCreatable/SubAccountCreatableCellRenderer.vue'

export const resolveCellRenderer = (actionable: Actionable) => {
    switch (actionable.type) {
        case ActionableType.Approve:
            return ApproveCellRenderer
        case ActionableType.Bookkeepable:
            return BookkeepingCellRenderer
        case ActionableType.SubAccountCreatable:
            return SubAccountCreatableCellRenderer
        default:
            return h('div', 'Not found')
    }
}
